import React from 'react'
import cx from 'classnames'
import { useTooltip, ToolTip } from 'components/common/ToolTip'
import Icon from 'components/common/Icon'
import { LockIcon } from 'components/common/AtsLock'

type ActionProps = {
  icon?: string
  label?: React.ReactNode
  small?: boolean
  primary?: boolean
  helpText?: React.ReactNode
  message?: React.ReactNode
  onClick?: React.MouseEventHandler<HTMLElement>
  warning?: boolean
  disabled?: boolean
}

type SwitchActionProps = ActionProps & {
  kebab?: boolean
}

// default action component
export const SwitchAction = ({
  kebab = false,
  disabled = false,
  ...props
}: SwitchActionProps) =>
  kebab ? (
    <MenuAction {...props} disabled={disabled} />
  ) : (
    <ToolAction {...props} disabled={disabled} />
  )

// action in a toolbar
export const ToolAction = ({
  icon,
  label,
  small = label ? false : true,
  primary = false,
  helpText,
  message,
  onClick,
  warning = false,
  disabled = false,
}: ActionProps) => {
  const [anchorProps, tetherProps] = useTooltip<HTMLDivElement>()
  const toolTipText = Boolean(message) ? message : helpText
  return (
    <>
      <div
        className={cx('Action', {
          small,
          primary: primary && !disabled,
          warning,
          disabled,
        })}
        onClick={disabled ? undefined : onClick}
        role="button"
        {...anchorProps}
      >
        {message && <LockIcon />}
        {icon && (
          <span className="icon">
            <Icon name={icon} />
          </span>
        )}
        {!small && label && <span className="label">{label}</span>}
      </div>
      {toolTipText && <ToolTip {...tetherProps}>{toolTipText}</ToolTip>}
    </>
  )
}

// action inside a dropdown (kebab) menu
export const MenuAction = ({
  icon,
  label = 'tool action',
  helpText,
  onClick,
  disabled = false,
  warning = false,
  primary = false,
  message,
}: ActionProps) => {
  const [anchorProps, tetherProps] = useTooltip<HTMLSpanElement>()
  return (
    <>
      <div
        onClick={disabled ? undefined : onClick}
        className={cx('MenuItemAction', {
          disabled,
          warning,
          primary: primary && !disabled,
        })}
      >
        {message && <LockIcon />}
        <span className="icon" {...anchorProps}>
          <Icon name={icon} />
        </span>
        <span className="label">{label}</span>
        <span className="helptext">{helpText}</span>
      </div>
      {message && <ToolTip {...tetherProps}>{message}</ToolTip>}
    </>
  )
}
